/**
 * Global Imports
*/

import { ChatUserstate } from 'tmi.js';

/**
 * Local Imports
*/

import { isUser, User, UserCreate } from '@system/User';

/**
 * Relative Imports
*/

import { ChatMessage, ChatEventHandler } from './types';

/**
 * Locals
*/

const events: Array<ChatEventHandler> = [];

/**
 * Public Functions
*/

/**
 * @param {string} channel
 * @param {User | ChatUserstate} user
 * @param {string} contents
 *
 * @return {ChatMessage}
 */
export function ChatCreateMessage(
  channel: string,
  user: User | ChatUserstate,
  contents: string): ChatMessage
{
  return {
    channel,
    contents,
    emotes: isUser(user) ? user.state.emotes : user.emotes,
    sentAt: new Date((isUser(user) ? user.state : user)['tmi-sent-ts']),
    user: isUser(user) ? user : UserCreate(user),
  };
}

/**
 * @param {ChatUserstate} state
 * @param {string} contents
 *
 * @return {ChatMessage}
 */
export function ChatAddEventHandler(
  channel: string,
  handler: ChatEventHandler): void
{
  events.push(handler);
}

/**
 * @param {string} channel
 * @param {User | ChatUserstate} user
 * @param {string} contents
 *
 * @return {void}
 */
export function ChatDispatch(
  channel: string,
  user: User | ChatUserstate,
  contents: string): void
{
  let message = ChatCreateMessage(channel, user, contents);
  let i = events.length;

  while (i--) {
    events[i](message);
  }
}
